import { __decorate, __param } from 'vscode/external/tslib/tslib.es6.js';
import { SyncDescriptor } from 'vscode/vscode/vs/platform/instantiation/common/descriptors';
import { IRequestService } from 'vscode/vscode/vs/platform/request/common/request.service';
import { IDecorationsService } from 'vscode/vscode/vs/workbench/services/decorations/common/decorations.service';
import { IJSONEditingService } from 'vscode/vscode/vs/workbench/services/configuration/common/jsonEditing.service';
import { ITreeViewsDnDService } from 'vscode/vscode/vs/editor/common/services/treeViewsDndService';
import { ITreeViewsService } from 'vscode/vscode/vs/workbench/services/views/browser/treeViewsService.service';
import { TreeViewsDnDService } from 'vscode/vscode/vs/editor/common/services/treeViewsDnd';
import { IURLService } from 'vscode/vscode/vs/platform/url/common/url.service';
import { JSONEditingService } from './vscode/src/vs/workbench/services/configuration/common/jsonEditingService.js';
import { DecorationsService } from './vscode/src/vs/workbench/services/decorations/browser/decorationsService.js';
import { BrowserRequestService } from './vscode/src/vs/workbench/services/request/browser/requestService.js';
import { BrowserURLService } from './vscode/src/vs/workbench/services/url/browser/urlService.js';
import { TreeviewsService } from './vscode/src/vs/workbench/services/views/common/treeViewsService.js';
import { CanonicalUriService } from './vscode/src/vs/workbench/services/workspaces/common/canonicalUriService.js';
import { ICanonicalUriService } from 'vscode/vscode/vs/platform/workspace/common/canonicalUri.service';
import { IUserActivityService } from 'vscode/vscode/vs/workbench/services/userActivity/common/userActivityService.service';
import { IDownloadService } from 'vscode/vscode/vs/platform/download/common/download.service';
import { DownloadService } from './vscode/src/vs/platform/download/common/downloadService.js';
import { IPathService } from 'vscode/vscode/vs/workbench/services/path/common/pathService.service';
import { IWorkingCopyFileService } from 'vscode/vscode/vs/workbench/services/workingCopy/common/workingCopyFileService.service';
import { IRemoteAgentService } from 'vscode/vscode/vs/workbench/services/remote/common/remoteAgentService.service';
import { IWorkbenchEnvironmentService } from 'vscode/vscode/vs/workbench/services/environment/common/environmentService.service';
import { IWorkspaceContextService } from 'vscode/vscode/vs/platform/workspace/common/workspace.service';
import { guessLocalUserHome } from './vscode/src/vs/workbench/services/path/browser/pathService.js';
import { AbstractPathService } from './vscode/src/vs/workbench/services/path/common/pathService.js';
import { UserActivityService } from './vscode/src/vs/workbench/services/userActivity/common/userActivityService.js';
import { WorkingCopyFileService } from './vscode/src/vs/workbench/services/workingCopy/common/workingCopyFileService.js';
import { getEnvironmentOverride } from 'vscode/workbench';

let BrowserPathServiceOverride = class BrowserPathServiceOverride extends AbstractPathService {
    constructor(remoteAgentService, environmentService, contextService) {
        super(getEnvironmentOverride().userHome ?? guessLocalUserHome(environmentService, contextService), remoteAgentService, environmentService, contextService);
    }
};
BrowserPathServiceOverride = __decorate([
    ( __param(0, IRemoteAgentService)),
    ( __param(1, IWorkbenchEnvironmentService)),
    ( __param(2, IWorkspaceContextService))
], BrowserPathServiceOverride);
function getServiceOverride() {
    return {
        [( IRequestService.toString())]: new SyncDescriptor(BrowserRequestService, [], true),
        [( IDownloadService.toString())]: new SyncDescriptor(DownloadService, [], true),
        [( IDecorationsService.toString())]: new SyncDescriptor(DecorationsService, [], true),
        [( IJSONEditingService.toString())]: new SyncDescriptor(JSONEditingService, [], true),
        [( ITreeViewsDnDService.toString())]: new SyncDescriptor(TreeViewsDnDService, [], true),
        [( ITreeViewsService.toString())]: new SyncDescriptor(TreeviewsService, [], true),
        [( IURLService.toString())]: new SyncDescriptor(BrowserURLService, [], true),
        [( ICanonicalUriService.toString())]: new SyncDescriptor(CanonicalUriService, [], false),
        [( IUserActivityService.toString())]: new SyncDescriptor(UserActivityService, [], true),
        [( IWorkingCopyFileService.toString())]: new SyncDescriptor(WorkingCopyFileService, [], false),
        [( IPathService.toString())]: new SyncDescriptor(BrowserPathServiceOverride, [], true)
    };
}

export { getServiceOverride as default };
